import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import apiClient from "@/app/api/client";
import type { PaginatedApiResponse, PaginationMeta } from "@/shared/types/pagination";

const EMPTY_META: PaginationMeta = { total: 0, page: 1, limit: 20, totalPages: 0 };

interface UsePaginatedQueryOptions {
	queryKey: unknown[];
	url: string;
	/** Qo'shimcha query parametrlari — filtrlar. */
	params?: Record<string, unknown>;
}

export function usePaginatedQuery<T>(options: UsePaginatedQueryOptions) {
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(20);

	const query = useQuery({
		queryKey: [...options.queryKey, page, limit, options.params],
		queryFn: async () => {
			const response = await apiClient.get<PaginatedApiResponse<T>>(options.url, {
				params: { page, limit, ...options.params },
			});
			return response.data.data;
		},
		// Sahifa almashganda jadval bo'shab ketmasin.
		placeholderData: keepPreviousData,
	});

	return {
		items: query.data?.items ?? [],
		meta: query.data?.meta ?? EMPTY_META,
		isLoading: query.isLoading,
		isFetching: query.isFetching,
		/**
		 * ⚠️ Chaqiruvchi bo'sh jadval bilan haqiqiy xatoni ADASHTIRMASLIGI
		 * kerak — `items` xato holatida ham `[]` bo'ladi (C2 Task 7b).
		 */
		isError: query.isError,
		page,
		limit,
		setPage,
		setLimit,
		refetch: query.refetch,
	};
}

export type PaginatedQueryResult<T> = ReturnType<typeof usePaginatedQuery<T>>;
